// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointFromJSON, DatapointToJSON, } from './';
export function DatapointsRequestItemFromJSON(json) {
    return {
        'id': json['id'],
        'measures': !exists(json, 'measures') ? undefined : json['measures'].map(DatapointFromJSON),
        'dimensions': !exists(json, 'dimensions') ? undefined : json['dimensions'].map(DatapointFromJSON),
    };
}
export function DatapointsRequestItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'measures': value.measures === undefined ? undefined : value.measures.map(DatapointToJSON),
        'dimensions': value.dimensions === undefined ? undefined : value.dimensions.map(DatapointToJSON),
    };
}
